/**
 * useFidoMutation / useWalletToggleMutation — F-012 Phase 3 (IMPL-P3-003).
 *
 * TanStack Query mutations for the two admin write paths:
 *  - `useFidoMutation(id)`       → PATCH /clienti/:id/fido
 *  - `useWalletToggleMutation(id)`→ PATCH /clienti/:id/wallet-toggle
 *
 * On success both invalidate the list (`['admin','clienti']`) and the detail
 * (`['admin','cliente', id]`) so the UI reflects the new fido/wallet state.
 *
 * Pattern: `features/archivio/hooks` + INTRODUCTION.md (invalidateQueries).
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { FidoDecision } from '@app/shared';

import {
  updateFido,
  toggleWallet,
  type FidoMutationResponse,
} from '../lib/admin-client';

export interface UpdateFidoVars {
  nuovoFidoEuro: number;
  motivazione: string;
  decision: FidoDecision;
}

export function useFidoMutation(id: string) {
  const queryClient = useQueryClient();
  return useMutation<FidoMutationResponse, Error, UpdateFidoVars>({
    mutationFn: (vars) => updateFido(id, vars),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['admin', 'clienti'] });
      void queryClient.invalidateQueries({ queryKey: ['admin', 'cliente', id] });
    },
  });
}

export function useWalletToggleMutation(id: string) {
  const queryClient = useQueryClient();
  return useMutation<FidoMutationResponse, Error, void>({
    mutationFn: () => toggleWallet(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['admin', 'clienti'] });
      void queryClient.invalidateQueries({ queryKey: ['admin', 'cliente', id] });
    },
  });
}
